
import React from 'react';

export const ChatDemoSection: React.FC = () => {
  const channels = [
    { name: 'WhatsApp' },
    { name: 'Instagram' },
    { name: 'Stripe' },
    { name: 'Google' },
    { name: 'ClinicPay' },
  ];

  return (
    <section className="py-24 bg-dark">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Chat Demo Box - Left Side */}
          <div className="bg-gradient-to-br from-gray-900 to-gray-800 border border-gray-700 rounded-3xl p-8 shadow-2xl">
            {/* Header */}
            <div className="flex items-center gap-4 mb-8">
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-cyan-400 to-pink-400 flex items-center justify-center">
                <span className="text-white text-2xl font-bold">M</span>
              </div>
              <div>
                <h3 className="text-white text-xl font-semibold">Mina IA</h3>
                <p className="text-cyan-400 text-sm font-medium uppercase tracking-wide">Online · WhatsApp & Instagram</p>
              </div>
            </div>
            
            {/* Chat Messages */}
            <div className="space-y-6">
              {/* Mina Message 1 */}
              <div className="bg-gray-800/80 border border-gray-700 rounded-2xl rounded-tl-sm p-5 max-w-[90%]">
                <p className="text-white text-base leading-relaxed">
                  Hola, soy Mina de Digital Line. ¿En qué puedo ayudarte con tus tratamientos hoy?
                </p>
              </div>
              
              {/* User Message */}
              <div className="flex justify-end">
                <div className="bg-gradient-to-r from-gray-700 to-gray-600 border border-gray-600 rounded-2xl rounded-tr-sm p-5 max-w-[90%]">
                  <p className="text-white text-base leading-relaxed">
                    Quiero información para un blanqueamiento y cuándo podéis atenderme.
                  </p>
                </div>
              </div>
              
              {/* Mina Message 2 */}
              <div className="bg-gray-800/80 border border-gray-700 rounded-2xl rounded-tl-sm p-5 max-w-[90%]">
                <p className="text-white text-base leading-relaxed italic">
                  "Puedo ofrecerte una primera cita este jueves a las 18:30. ¿Te la reservo?"
                </p>
              </div>
            </div>
          </div>
          
          {/* Features - Right Side */}
          <div className="space-y-8">
            <div>
              <span className="text-xs font-semibold text-primary uppercase tracking-[0.2em] mb-4 block">
                Mina en acción
              </span>
              <h2 className="text-4xl lg:text-5xl font-display font-semibold text-white mb-6">
                Así trabaja Mina por ti
              </h2>
            </div>
            
            {/* Feature 1 - Velocidad Inhumana */}
            <div className="flex gap-5">
              <div className="w-14 h-14 flex-shrink-0 flex items-center justify-center bg-gradient-to-br from-cyan-400/20 to-cyan-400/10 border border-cyan-400/30 rounded-2xl">
                <i className="ri-flashlight-line text-2xl text-cyan-400"></i>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-white mb-2">
                  Velocidad Inhumana
                </h3>
                <p className="text-gray-400 leading-relaxed italic">
                  Respuesta en 3 segundos. El cliente caliente compra. Mina atiende a las 3:00 AM o en domingo, asegurando que ningún lead se vaya a la competencia.
                </p>
              </div>
            </div>
            
            {/* Feature 2 - Venta Neuronal */}
            <div className="flex gap-5">
              <div className="w-14 h-14 flex-shrink-0 flex items-center justify-center bg-gradient-to-br from-pink-400/20 to-pink-400/10 border border-pink-400/30 rounded-2xl">
                <i className="ri-lightbulb-line text-2xl text-pink-400"></i>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-white mb-2">
                  Venta Neuronal
                </h3>
                <p className="text-gray-400 leading-relaxed italic">
                  Detecta objeciones, valida emociones y sugiere upsells para aumentar tu ticket medio de forma automática y empática.
                </p>
              </div>
            </div>
            
            {/* Feature 3 - Reactivación Proactiva */}
            <div className="flex gap-5">
              <div className="w-14 h-14 flex-shrink-0 flex items-center justify-center bg-gradient-to-br from-yellow-400/20 to-yellow-400/10 border border-yellow-400/30 rounded-2xl">
                <i className="ri-notification-3-line text-2xl text-yellow-400"></i>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-white mb-2">
                  Reactivación Proactiva
                </h3>
                <p className="text-gray-400 leading-relaxed italic">
                  Detecta patrones de ausencia y lanza mensajes personalizados para recuperar pacientes que hace meses no vienen a tu clínica.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Channels Section */}
        <div className="mt-24 text-center">
          <p className="text-gray-400 text-2xl uppercase tracking-[0.25em] mb-10">
            Mina se incorpora a tus canales de ventas
          </p>
          <div className="flex flex-wrap justify-center items-center gap-12 lg:gap-20">
            {channels.map((channel) => (
              <span
                key={channel.name}
                className="text-2xl lg:text-3xl font-semibold italic text-gray-500 cursor-pointer transition-all duration-300 hover:bg-gradient-to-r hover:from-pink-400 hover:to-cyan-400 hover:bg-clip-text hover:text-transparent"
              >
                {channel.name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
